import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import {
  login,
  google,
  facebook,
  linkedIn,
} from "../../Store/Actions/authActions";
import SocialLogin from "../SocialLogin/socialLogin";
import "./Login.scss";
import useForm from "../../hooks/login/useForm";
import validate from "../../validation/UserCustomerLoginFormValidationRules";
import ButtonLink from "../Buttons/ButtonLink/ButtonLink";
import { ResumePopupContext } from "../../Context/resumePopupContext";
import GuestPopUp from "../../Components/GuestPopup/guestPopup";
import { RESUME_CREATE_RESET } from "../../Store/Constants/ResumeConstants";
import { createResumes } from "../../Store/Actions/ResumeActions";
import { createCoverLetter } from "../../Store/Actions/CoverLetterActions";
import { COVER_CREATE_RESET } from "../../Store/Constants/CoverLetterConstants";
import { ToastContainer, toast } from "react-toastify";
import { sampleResumeById } from "../../Store/Actions/ResumeActions";
import "react-toastify/dist/ReactToastify.min.css";

function Login(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [social, setSocial] = useState(false);
  const path = window.location.pathname;
  const loadUserData = useSelector((state) => state.userData.userInfo);
  const error = useSelector((state) => state.userData);
  const [loginError, setLoginError] = useState("");
  const editorData = useSelector((state) => state.editorData);
  const coverData = useSelector((state) => state.coverData);
  const create = useSelector((state) => state.createResume);
  const coverCreate = useSelector((state) => state.coverCreate);
  const { resume } = useSelector((state) => state.resumeGetById);
  const { coverLetter } = useSelector((state) => state.coverParticular);
  const forgotpassworddata = useSelector((state) => state.forgotpassword);

  //Context
  const { guestPopup, setGuestPopup } = useContext(ResumePopupContext);

  const handlesocial = (value) => {
    setSocial(value);
  };

  function getCookie(key) {
    var b = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    return b ? b.pop() : "";
  }

  const [content, setContent] = useState({
    title: resume && resume.title ? resume && resume.title : "Untitled",
    thumb: "",
    type: "resume",
    content: JSON.stringify(props.resumeFields),
    isLetter: 0,
    completed: false,
    template_id: resume && resume.template_id,
  });

  const [coverContent, setCoverContent] = useState({
    title: resume && resume.title ? resume && resume.title : "Untitled",
    thumb: "",
    type: "cover_letter",
    content: JSON.stringify(coverData),
    isLetter: 0,
    completed: false,
    template_id: coverLetter && coverLetter.template_id,
  });
  //   useEffect(() => {
  //     if (forgotpassworddata && forgotpassworddata.password) {
  //       toast.success(forgotpassworddata.password.message);
  //     }
  //   }, [forgotpassworddata]);

  // for console purpose
  const sampleID = getCookie("sample");
  const downloadpdf = getCookie("downloadpdf");
  const customize = getCookie("customize");
  const cover = getCookie("cover");
  const coverSample = getCookie("coverSample");

  useEffect(() => {
    if (loadUserData && loadUserData.token) {
      if (!props.admin) {
        if (props && props.isModal) {
          if (props && props.active && props.active == "login" && !social) {
            if (path && path.includes("create-cover")) {
              dispatch(createCoverLetter(coverContent));
            } else {
              dispatch(createResumes(content));
            }
          }
        } else {
          //  const localTemplateId = localStorage.getItem("onboardingTemplate");
          const sampleID = getCookie("sample");
          const downloadpdf = getCookie("downloadpdf");
          const customize = getCookie("customize");
          const cover = getCookie("cover");
          const coverSample = getCookie("coverSample");
          if (sampleID && sampleID != "") {
            if (downloadpdf == "true") {
              history.replace(
                `/create-resume/sample/${sampleID}/?refer=download_pdf`
              );
            } else if (customize == "true") {
              history.replace(
                `/create-resume/sample/${sampleID}/?refer=customize`
              );
            } else {
              history.replace(
                `/create-resume/sample/${sampleID}/?refer=onboarding`
              );
            }
          } else if (coverSample && coverSample != "" && cover == "true") {
            history.replace(`/create-cover/sample/${coverSample}?refer=App`);
          } else {
            history.push("/home");
          }
        }
        // history.push("/home");
        setGuestPopup(false);
      } else {
        history.push("/admin/dashboard");
      }
    }
  }, [loadUserData]);

  const onSubmit = (e) => {
    dispatch(login(user.email, user.password));
  };
  const { handleSubmit, handleChange, errors, user } = useForm(
    onSubmit,
    validate
  );

  useEffect(() => {
    if (
      coverCreate &&
      coverCreate.data &&
      coverCreate.data.type &&
      coverCreate.data.type === "cover_letter"
    ) {
      history.push(`/coverletter/${coverCreate.data.id}`);
      dispatch({ type: COVER_CREATE_RESET });
    }
  }, [coverCreate]);

  useEffect(() => {
    if (
      create &&
      create.create &&
      create.create.type &&
      create.create.type === "resume"
    ) {
      history.push(`/resumes/${create.create.id}`);
      dispatch({ type: RESUME_CREATE_RESET });
    }
  }, [create]);

  useEffect(() => {
    if (!props.isModal) {
      setEmail(user.email);
    }
  }, [user]);

  useEffect(() => {
    if (error) {
      setLoginError(error);
    }
  }, [error]);
  const showReset = () => {
    if (props && props.isModal) {
      props.handleActive("reset");
    } else {
      if (email) {
        history.push(`/forgot_password?email=${email}`);
      } else {
        history.push(`/forgot_password`);
      }
    }
  };

  const guestLogin = () => {
    setGuestPopup(true);
  };

  const hideLogin = () => {
    if (props && props.isModal) {
      props.handleActive("signup");
    } else {
      history.push("/signup");
    }
  };

  const handleTerms = () => {
    window.open(
      "https://www.qwikresume.com/terms-of-service/",
      "_blank",
      "noopener,noreferrer"
    );
  };
  const handlePrivacy = () => {
    window.open(
      " https://www.qwikresume.com/privacy-policy/",
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <>
      <ToastContainer
        toastStyle={{
          backgroundColor: "#009c61",
          width: "203px",
          fontSize: "12px",
          minHeight: "30px",
          float: "right",
          marginTop: "15%",
        }}
        position="top-right"
        hideProgressBar
        autoClose={2000}
        draggable
      />
      {/* <GuestPopUp isModal={props.isModal} /> */}

      {!props.isOnboarding && (
        <>
          <img
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/logo.svg`}
            alt="logo"
            className="logo"
          />
          <h4 className="maintitle">Login to your Account</h4>
          <p className="titledesc">
            New User?
            <span>
              <span
                className="primarycolor pb-1 ml-2 dashedbottom"
                onClick={hideLogin}
              >
                Sign up for a new account
              </span>
            </span>
          </p>
        </>
      )}
      <SocialLogin
        isModal={props.isModal}
        active={props && props.isModal ? "social" : ""}
        handlesocial={handlesocial}
        social={social}
        resumeFields={props.resumeFields}
      />

      <p className="logtype">or log in with email</p>
      <form onSubmit={handleSubmit}>
        <div>
          {loginError && loginError.error && !loginError.error.guest && (
            <p className="error">{loginError.error}</p>
          )}

          <input
            type="text"
            className="form-control primaryinput mb-3"
            placeholder="Registered Email"
            name="email"
            autoComplete="on"
            onChange={handleChange}
          />
          {errors && errors.email && <p className="error">{errors.email}</p>}
          <input
            type="password"
            className="form-control primaryinput mb-3"
            placeholder="Password"
            name="password"
            autoComplete="on"
            onChange={handleChange}
          />
          {errors && errors.password && (
            <p className="error">{errors.password}</p>
          )}
          <div className="d-flex align-items-start justify-content-end">
            <ButtonLink click={showReset} title="Forgot Password?" />
          </div>
          <button type="submit" className="btn successbtn btn-block mt-3">
            Submit
          </button>
        </div>
      </form>
      <div className="my-3 ">
        <div className="text-center">
          <p className="mb-0 termcontent ">
            By using QwikResume, you agree to our
          </p>
          <p className="mb-0 terms cursor">
            <span onClick={handleTerms}>Terms of Service</span>{" "}
            <span className="text-dark ">&</span>{" "}
            <span onClick={handlePrivacy}>Privacy Policy.</span>
          </p>
        </div>
      </div>
      {/* {props && props.isModal ? (
        ""
      ) : (
        <button onClick={guestLogin} className="btn primarybtn w-100 my-3">
          Create a Resume without an account
        </button>
      )} */}
    </>
  );
}

export default Login;
